import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/request'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'

Vue.config.productionTip = false

Vue.prototype.$env = {
  module: {
    // 校招
    school: 3,
    // 社招
    agency: 4
  },
  article: {
    // 关于aosom
    about: 1,
    // 薪酬福利
    welfare: 2
  },
  link: {
    special: 'http://xyz.51job.com/External/Apply.aspx?CtmID=4926856',
    school: {},
    agency: {
      zhilian: 'https://landing.zhaopin.com/register?utm_source=baidupcpz&utm_medium=cpt&utm_provider=partner&sid=121113803',
      job51: 'https://jobs.51job.com/all/co6070307.html'
    }
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
